import React, { useContext, useEffect, useState } from "react";
import { StarRating as StarRatingType } from "../@types";
import { getOriginalMedicareStarRatings } from "../api";
import { AppStore } from "../app/store";
import { useTranslate } from "../helpers";
import HelpDrawerWrapper from "./HelpDrawerWrapper";
import StarRating from "./StarRating";

const OriginalMedicareStarRatings: React.FunctionComponent = () => {
  const t = useTranslate();
  const {
    state: { fips, year },
  } = useContext(AppStore.AppContext);
  const [ratings, setRatings] = useState<StarRatingType[]>([]);
  const [error, setError] = useState("");

  async function fetchStarRatings(): Promise<void> {
    if (fips && year) {
      try {
        const stars = await getOriginalMedicareStarRatings(fips, year);
        if (stars.length) {
          setRatings(stars);
        } else {
          setError(t("om_stars.error_message"));
        }
      } catch (e) {
        setError(t("om_stars.error_message"));
      }
    }
  }

  useEffect(() => {
    fetchStarRatings();
  }, [fips, year]);

  return (
    <HelpDrawerWrapper
      toggleText={t("om_stars.view_how_plan_compares")}
      drawerTitle={t("om_stars.view_how_plan_compares")}
      tealiumProps={{
        callingLabel: "Plan Details",
        label: "Original Medicare Star Ratings",
      }}
    >
      {error ? (
        <p>{error}</p>
      ) : (
        <table className="OriginalMedicareStarRatingsTable" cellSpacing={0}>
          <thead>
            <tr>
              <th>{t("om_stars.category_column_heading")}</th>
              <th>{t("om_stars.star_column_heading")}</th>
            </tr>
          </thead>
          <tbody>
            {ratings.map(rating => {
              return (
                <tr key={rating.category}>
                  <td>{t(`om_stars.${rating.category.toLowerCase()}`)}</td>
                  <td>
                    <StarRating
                      stars={rating}
                      includeLabel={false}
                      planYear={year || ""}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </HelpDrawerWrapper>
  );
};

export default OriginalMedicareStarRatings;
